import { Box, Button, ButtonBase, makeStyles, TextField, Typography } from "@material-ui/core"
import React, { Fragment, useEffect, useState } from "react"
import { useHistory, useLocation, useParams } from "react-router"
import { useFeedback } from "../components/Feedback"
import NationalCodeSelect from "../components/NationalCodeSelect"
import { updateChannelVisit, checkMobile, channelRegister, channelRegister2, getChannelDisplayInfo } from "../utils/api"

const useStyles = makeStyles({
    textWrapper: {
        backgroundImage: 'linear-gradient(180deg, #5FA6DB 0%, #006CB9 100%)',
        color: '#fff',
        padding: '12px 8px',
        borderRadius: '6px',
        margin: '0 24px'
    },
    button: {
        width: '264px',
        height: '56px',
        fontSize: '18px',
        borderRadius: '24px',
        letterSpacing: '1.5px',
        backgroundImage: 'url(https://res.add-coach.com/img/event/event_button_1.png)',
        backgroundSize: '264px 56px',
        backgroundColor: 'transparent',
        color: '#fff'
    },
    toDown: {
        position: 'absolute'
    }
})

const Share = () => {
    const classes = useStyles()
    const { showLoading, hideLoading, showToast } = useFeedback();
    const [displayInfo, setDisplayInfo] = useState({
        display_name: '',
        present_coin: ''
    })
 
    const [codePageShow] = useState(false)
    const { id } = useParams<{ id: string }>()
    const [state, setState] = useState({
        mobile: '',
        nationalCode: '86',
        vcode: ''
    })

    const [toDwonXy, setToDwonXy] = useState({
        top: 0,
        left: 0,
        size: 25
    })
    const getStyles = () => {
        const styles = { top: toDwonXy.top, left: toDwonXy.left }
        return styles;
    }
    const getStyles2 = () => {
        const styles = { fontSize: toDwonXy.size, color: '#0e719b', fontWeight: 600 }
        return styles;

    }




    const handleInputChange = (key: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
        setState({ ...state, [key]: event.target.value.split(' ').join('') })
    }

    const [resendState, setResendState] = React.useState({
        resend: true,
        resendText: '发送验证码'
    })

    React.useEffect(() => {
        const timer = () => {
            let time = 60;
            return window.setInterval(() => {
                time--;
                if (time > 0) {
                    setResendState({ ...resendState, resendText: time + '秒后重新发送' })
                } else {
                    setResendState({ ...resendState, resendText: '发送验证码', resend: true })
                }
            }, 1000)
        }
        let resendTimer: number;
        if (!resendState.resend) {
            resendTimer = timer()
        }
        return () => {
            resendTimer && window.clearInterval(resendTimer)
        }

    }, [resendState.resend])

    useEffect(() => {
        updateChannelVisit(id)
        getChannelDisplayInfo(id).then(res => {
            setDisplayInfo(res.data);
        })
        document.title = '爱到底-迎新免费领爱豆';
        console.info(state.mobile)

        const wW = document.documentElement.clientWidth
        setToDwonXy({
            top: Math.floor(wW * 504 / 750),
            left: Math.floor(wW * 458 / 750),
            size: Math.floor(wW * 25 / 750)
        })
    }, [])


    const vcodeDisable = () => {
        return state.mobile && resendState.resend
    }

    const handleSendVcode = () => {
        if (!state.mobile) {
            showToast('请输入手机号后继续领取')
            return;
        }
        if (!(state.nationalCode == '86' ? /^1[3456789]\d{9}$/.test(state.mobile) : /^\d{6,}$/.test(state.mobile))) {
            showToast('手机号格式不正确')
            return;
        }
        showLoading('')
        checkMobile(state.mobile, state.nationalCode).then(res => {
            if (res.exist) {
                hideLoading()
                showToast('该手机号已注册，活动仅限未注册爱到底APP的用户参加')
            } else {
                //无需验证下载
                channelRegister2(state.mobile, state.nationalCode, id).then(res => {
                    hideLoading()
                    // showToast('领取成功')
                    toDownload()
                }).catch(e => {
                    hideLoading()
                    showToast(e.msg)
                })
            }
        }).catch(error => {
            setResendState({ ...resendState, resend: true })
            hideLoading()
            showToast(error.msg)
        });

    }

    const toDownload = () => {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
            window.location.href = "https://apps.apple.com/cn/app/id1524611239";
        } else if (/(Android)/i.test(navigator.userAgent)) {  //判断Android
            window.location.href = "https://a.app.qq.com/o/simple.jsp?pkgname=com.rootedu.android.client";
        } else { //pc
            window.location.href = "https://a.app.qq.com/o/simple.jsp?pkgname=com.rootedu.android.client";
        };
    }

    const handleGetCoin = () => {
        if (!state.vcode) {
            showToast('请输入验证码')
            return;
        }
        showLoading('')
        checkMobile(state.mobile, state.nationalCode).then(res => {
            if (res.exist) {
                hideLoading()
                showToast('该手机号已注册，活动仅限未注册用户参加')
            } else {
                channelRegister(state.mobile, state.nationalCode, state.vcode, id).then(res => {
                    hideLoading()
                    // showToast('领取成功')
                    toDownload()
                }).catch(e => {
                    hideLoading()
                    showToast(e.msg)
                })
            }
        }).catch(e => {
            hideLoading()
        })
    }


    return <Fragment>
        {!codePageShow && <Box minHeight="100vh" bgcolor="#f5f9fb" >
            <img src="https://res.add-coach.com/img/event/event_header.jpg" width="100%" />
            <Box className={classes.toDown} style={getStyles()}>
                <Typography align="left" style={getStyles2()} onClick={toDownload}>下载APP</Typography>
            </Box>

            <Box style={{ marginTop: '8' }} pl={3} pr={3}>
                {displayInfo && <Typography variant="body2" align="center" style={{ lineHeight: '1.5', fontSize: '20px', color: '#e0803a', fontWeight: 600 }}>
                    {displayInfo.display_name}赠送您的{displayInfo.present_coin}个爱豆（价值{displayInfo.present_coin}元）
                </Typography>}
            </Box>
            <Box mt={2} display="flex" justifyContent="center" >
                <Box display="flex" width="64%" justifyContent="center" alignItems="center">
                    <TextField
                        variant="outlined"
                        size="small"
                        label="手机号"
                        fullWidth
                        value={state.mobile}
                        onChange={handleInputChange('mobile')}
                        InputProps={{ startAdornment: <NationalCodeSelect style={{ height: '36px', width: '90px' }} onChange={handleInputChange('nationalCode')} value={state.nationalCode} /> }}
                    />
                </Box>
            </Box>
            <Box mt={2} textAlign="center">
                <ButtonBase className={classes.button} onClick={handleSendVcode}>下载APP，领取爱豆</ButtonBase>
            </Box>

            <Box className={classes.textWrapper} style={{ marginTop: '24px' }}>
                <Typography variant="body2" align="justify" style={{ lineHeight: '1.5' }}>所获赠的爱豆将直接存入您的爱到底APP账户，可直接用于购买“爱到底”APP内所有课程和教练服务，包括特惠首次教练约谈。</Typography>
            </Box>

        </Box>}
        {codePageShow && <Box minHeight="100vh" bgcolor="#f5f9fb">
            <img src="https://res.add-coach.com/img/event/event_header2.jpg" width="100%" />

            <Box display="flex" justifyContent="center" mt={3}>
                <Box display="flex" alignItems="baseline" width="268px" boxSizing="border-box" pl={1.5}>
                    <TextField type="number" style={{ flexGrow: 1 }} placeholder="请输入验证码" value={state.vcode} onChange={handleInputChange('vcode')} />
                    <Button style={{ width: '120px', flexShrink: 0, fontSize: '12px' }} variant="text" disabled={!vcodeDisable()} onClick={handleSendVcode} color="secondary">{resendState.resendText}</Button>
                </Box>
            </Box>
            <Box textAlign="center" mt={2}>
                <ButtonBase onClick={handleGetCoin} className={classes.button}>安装APP查看我的爱豆</ButtonBase>
            </Box>
            <Box display="flex" flexDirection="column" mt={1}>
                <Typography align="center" color="textSecondary" variant="caption">安装“爱到底”APP注册后，</Typography>
                <Typography align="center" color="textSecondary" variant="caption">您可以到您的账户查看获赠的{displayInfo.present_coin}爱豆。</Typography>
            </Box>
            <Box className={classes.textWrapper} style={{ marginTop: '24px' }}>
                <Typography variant="body2" align="justify" style={{ lineHeight: '1.8' }}>
                    强烈推荐爱到底的VIP会员服务，388元/年。VIP会员将以4折的价格获得原价897元的全球ADHD权威专家巴克利博士专门为中国家长录制的《ADHD及其共症解读&治疗指南》大师课的全部内容。
                </Typography>
            </Box>
            <Box margin={3}>
                <img src="https://res.add-coach.com/img/event/event_detail_1.png" width="100%" />
            </Box>

        </Box>}
    </Fragment>
}

export default Share